import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSidebarVisible } from '../../redux/Reducer/AdminAccount/AccountSlice';
import Menu from '../common/icons/Menu';

const AdminSidebarToggle = ({ className = "" }) => {
  const dispatch = useDispatch();
  const isSidebarVisible = useSelector((state) => state.admin?.isSidebarVisible);

  if (isSidebarVisible) return null;

  return (
    <button
      type="button"
      onClick={() => dispatch(setSidebarVisible(true))}
      className={`flex items-center justify-center bg-transparent border-none rounded-[8px] min-w-[40px] hover:bg-primary-50 transition-all duration-300 z-[99] p-2 hover:scale-105 active:scale-95 ${className}`}
      title="Show Sidebar"
    >
      <Menu fill="#513E3E" height={28} width={28} />
    </button>
  );
};

export default AdminSidebarToggle;
